// Constants
import { UPLOAD_ID_DIFFERENT_DATA_CUSTOMER_DATA_CONFIGURATION } from './constants/upload-id-different-data.configuration.constants';
// Types
import {
  UploadIdDifferentDataItemConfigurationType,
  UploadIdDifferentDataReturnItemConfigurationType,
} from './types/upload-id-different-data.configuration.type';
import { UploadIdDifferentDataHookType } from '../hooks/types/upload-id-different-data.hook.type';
// Utilities
import { mapBirthDateLabelOrOther } from './utils/upload-id-different-data.configuration.utils';

const getDifferentDataResumeItemsConfiguration = ({
  formatMessage,
  formatDate,
  customerData,
}: Pick<
  UploadIdDifferentDataHookType,
  'customerData' | 'formatMessage' | 'formatDate'
>): UploadIdDifferentDataReturnItemConfigurationType[] =>
  UPLOAD_ID_DIFFERENT_DATA_CUSTOMER_DATA_CONFIGURATION.map(
    ({
      id,
      label,
    }: UploadIdDifferentDataItemConfigurationType): UploadIdDifferentDataReturnItemConfigurationType => ({
      description: mapBirthDateLabelOrOther({ customerData, formatDate, id }),
      label: formatMessage({ id: label }),
    })
  );

export { getDifferentDataResumeItemsConfiguration };
